import { MockFactory } from '@tino-frontend/mocks'
import {
  BillInvoiceInstallmentsMopStatus,
  InstallmentStatus,
  MerchantGetInvoiceResponse,
} from '@types'
import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'

const installment1 = lineItemInstallment.build(
  {
    ...lineItemInstallment.source,
    amount_cents: 66666,
    metadata: {
      ...lineItemInstallment.source.metadata,
      installment_id: 'invoice_installments_id_1',
      tax_invoice_number: null,
    },
  },
  { mergeObject: false }
)

export const listDebitMock = new MockFactory<MerchantGetInvoiceResponse>({
  invoice: {
    amount_cents: 200000,
    original_amount_cents: 199800,
    merchant_service_fee_amount_cents: 200,
    buyer_company_id: 'buyer_company_id_1',
    buyer_name: 'Buyer Company Ltda.',
    created_at: '2021-03-31T11:45:25.126666Z',
    deal_conditions: [10, 30, 60],
    description: 'Test 2',
    due_date: '2021-04-10T00:00:00Z',
    id: 'id_1',
    installments: 2,
    invoice_installments: [
      {
        transaction_id: 'transaction_id',
        amount_cents: 66666,
        buyer_conciliated_amount: 66661,
        buyer_conciliation_status: InstallmentStatus.Settled,
        id: 'invoice_installments_id_1',
        line_code: '',
        mop_status: BillInvoiceInstallmentsMopStatus.Created,
        settlement_date: '2023-06-29T00:00:00Z',
        status: InstallmentStatus.Settled,
        url: '',
      },
    ],
    seller_company_id: 'seller_company_id_1',
    seller_name: 'Marco Polo Ltda.',
    short_id: 'short_id_1',
    external_id: 'external_id_1',
    status: 'confirmed',
  },
  line_items: [installment1],
  nfe_download_token: '',
})
